import React from 'react';
import { compose } from 'redux';
import { withAsync } from '@helpcenter/with-async';
import { useIntl } from 'react-intl';
import { lazyForPaint } from 'react-loosely-lazy';
import { withRouter, type Route } from 'react-resource-router';
import { withOnlyJiraAdmin } from 'view/common/with-only-jira-admin';
import { withOnlyLoggedIn } from 'view/common/with-only-logged-in';
import { authPageMessage, callToActionUrlText } from 'view/portal-reorder-experience';
import { AdminManagementLayout } from '@atlassian/admin-layout';
import { HelpCenterVirtualAgentResource } from '@atlassian/help-center-virtual-agent-settings/src/resource';

const AsyncVirtualAgentPage = withAsync({
	loader: lazyForPaint(() =>
		import(
			/* webpackChunkName: "async-help-center-virtual-agent-page" */ '@atlassian/help-center-virtual-agent-settings'
		).then((VirtualAgentSettingsPage) => VirtualAgentSettingsPage),
	),
});

const VirtualAgentPage = () => {
	const { formatMessage } = useIntl();
	const WrappedComponent = compose(
		withOnlyLoggedIn({
			redirectUrl: '/',
		}),
		withOnlyJiraAdmin({
			message: formatMessage(authPageMessage),
			callToActionText: formatMessage(callToActionUrlText),
			callToActionUrl: '/portals',
		}),
	)(() => (
		<AdminManagementLayout featureName="Virtual Agent Settings">
			<AsyncVirtualAgentPage />
		</AdminManagementLayout>
	));
	return <WrappedComponent />;
};

export const helpcenterVirtualAgentRoute: Route = {
	name: 'virtualAgentSettings',
	path: '/:helpcenterId/virtual-agent',
	exact: true,
	resources: [HelpCenterVirtualAgentResource],
	component: withRouter(VirtualAgentPage),
};
